export { default as NSwitch, switchProps } from './src/Switch';
